import { forwardRef } from "react";

export function cn(...a) {
  return a.filter(Boolean).join(" ");
}

export function Spinner({ className = "" }) {
  return (
    <div
      className={cn("inline-block h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent", className)}
    />
  );
}

export const Button = forwardRef(function Button(
  { variant = "primary", className = "", loading, disabled, children, ...props },
  ref,
) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-[15px] font-semibold transition-opacity duration-200 disabled:opacity-40 select-none";
  const variants = {
    primary: "bg-primary text-primary-foreground hover:opacity-80",
    secondary: "border border-border bg-secondary text-secondary-foreground hover:opacity-80",
    ghost: "text-foreground hover:opacity-70",
  };
  return (
    <button ref={ref} className={cn(base, variants[variant], className)} disabled={disabled || loading} {...props}>
      {loading ? <Spinner className="h-4 w-4" /> : children}
    </button>
  );
});

export function Field({ label, className = "", ...props }) {
  return (
    <label className="flex flex-col gap-1.5">
      {label ? <span className="text-xs font-semibold text-muted-foreground">{label}</span> : null}
      <input
        className={cn(
          "w-full rounded-xl border border-input bg-background px-4 py-3 text-[15px] text-foreground outline-none placeholder:text-muted-foreground focus:border-foreground",
          className,
        )}
        {...props}
      />
    </label>
  );
}
